module.exports = __webpack_public_path__ + "static/setup-9b20f3afa523a2cdb88e5b31dc6c4953.png";